import * as React from 'react';
import { UseFormReturn } from 'react-hook-form';

import { cn } from 'utils/cn';

import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from './form';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
    ({ className, type, ...props }, ref) => {
        return (
            <input
                type={type}
                className={cn(
                    'flex h-10 w-full rounded-md border px-3 py-2',
                    'border-input bg-background ring-offset-background',
                    'placeholder:text-muted-foreground text-sm',
                    'file:text-foreground file:border-0 file:bg-transparent file:text-sm file:font-medium',
                    'focus-visible:outline-none',
                    'disabled:cursor-not-allowed disabled:opacity-50',
                    className,
                )}
                ref={ref}
                {...props}
            />
        );
    },
);
Input.displayName = 'Input';

interface FormInputProps {
    formMethods: UseFormReturn<any, any, any>;
    name: string;
    label?: string;
    placeholder?: string;
    description?: string;
    defaultValue?: string;
    type?: string;
    required?: boolean;
    onBlur?: () => void;
}

const FormInput = (props: FormInputProps) => {
    return (
        <FormField
            defaultValue={props.defaultValue ?? ''}
            control={props.formMethods.control}
            name={props.name}
            render={({ field }) => (
                <FormItem className="flex flex-col gap-2">
                    {props.label && <FormLabel>{props.label}</FormLabel>}
                    <FormControl>
                        <Input
                            {...field}
                            placeholder={props.placeholder}
                            type={props.type}
                            required={props.required}
                            onBlur={props.onBlur}
                        />
                    </FormControl>
                    {props.description && <FormDescription>{props.description}</FormDescription>}
                    <FormMessage />
                </FormItem>
            )}
        />
    );
};

FormInput.displayName = 'FormInput';

export { Input, FormInput };
